module.exports = __webpack_public_path__ + "img/logo_web.4bc9d897.svg";